import {
  type Diagnostic,
  type RoutineView,
  type ValidationContext,
  type ValidationRule,
} from '../types';

export function createStepRule(opts: {
  id: string;
  stepKinds: string[];
  run: (args: {
    routine: RoutineView;
    ctx: ValidationContext;
    stepId: string;
  }) => Diagnostic[];
}): ValidationRule {
  return {
    id: opts.id,
    appliesTo: 'step',
    stepKinds: opts.stepKinds,
    run: ({ routine, ctx, stepId }) => {
      if (!stepId) return [];

      return opts.run({ routine, ctx, stepId });
    },
  };
}

export function diag(error: {
  code: string;
  message: string;
  stepId: string;
  fieldId?: string;
  severity?: 'error' | 'warning';
  sourceRule: string;
}): Diagnostic {
  return {
    code: error.code,
    message: error.message,
    severity: error.severity ?? 'error',
    stepId: error.stepId,
    fieldId: error.fieldId,
    sourceRule: error.sourceRule,
  };
}
